import axios from "axios";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

export default function EditProduct() {
  const [productData, setProductData] = useState({});

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const params = useParams();

  const getAndSetProductData = async () => {
    try {
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAndSetProductData();
  }, []);

  const onProductEditSubmit = async (e) => {
    e.preventDefault();

    try {
      axios.patch(
        `${process.env.REACT_APP_API_URL}/admin/products/` + params.id
      );
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container my-5 d-flex flex-column justify-content-center align-items-center">
      <form className="w-50" onSubmit={handleSubmit(onProductEditSubmit)}>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="name" class="form-label">
            Name
          </label>
          <input
            type="text"
            class="form-control"
            id="name"
            aria-describedby="Name"
          />
        </div>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="stock" class="form-label">
            Stock
          </label>
          <input
            type="text"
            class="form-control"
            id="stock"
            aria-describedby="Stock"
          />
        </div>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="stock" class="form-label">
            Stock
          </label>
          <input
            type="text"
            class="form-control"
            id="stock"
            aria-describedby="Stock"
          />
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
          />
          <label class="form-check-label" for="flexCheckDefault">
            Featured
          </label>
        </div>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="stock" class="form-label">
            Stock
          </label>
          <input
            type="text"
            class="form-control"
            id="stock"
            aria-describedby="Stock"
          />
        </div>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="stock" class="form-label">
            Stock
          </label>
          <input
            type="text"
            class="form-control"
            id="stock"
            aria-describedby="Stock"
          />
        </div>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="stock" class="form-label">
            Stock
          </label>
          <input
            type="text"
            class="form-control"
            id="stock"
            aria-describedby="Stock"
          />
        </div>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="stock" class="form-label">
            Stock
          </label>
          <input
            type="text"
            class="form-control"
            id="stock"
            aria-describedby="Stock"
          />
        </div>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="stock" class="form-label">
            Stock
          </label>
          <input
            type="text"
            class="form-control"
            id="stock"
            aria-describedby="Stock"
          />
        </div>
        <div class="mb-3 d-flex flex-column justify-content-start align-items-start">
          <label for="stock" class="form-label">
            Stock
          </label>
          <input
            type="text"
            class="form-control"
            id="stock"
            aria-describedby="Stock"
          />
        </div>
        <button type="submit" class="btn btn-primary">
          Submit
        </button>
      </form>
    </div>
  );
}
